// @ts-check
export const ADDED = "added";
export const REMOVED = "removed";
export const MOVED = "moved";
